module.exports = __webpack_public_path__ + "img/baidu_netdisk.a30dbfbd.svg";